import { api } from '@/core/helpers/axiosHelper';
import { CancelToken } from 'axios';
import { MediumTypeKey } from '../availability-todo/availability-todo.interface';
import { CandidatePool } from '../candidate-pool/candidate-pool.interface';
import { Shift } from '../shift/shift.interface';
import { SlotHour } from '../slot-hour/slot-hour.interface';
import { SlotStateKey } from '../slot-state/slot-state.interface';
export const SLOT_INCLUDES = [
   'slot_state',
   'shift',
   'candidate_pool.pool',
   'candidate_pool.candidate.language',
   'candidate_pool.candidate.tenant',
   'candidate_pool.candidate.user',
   'slot_contract_state',
   'slot_hours',
   'shift.squad.board',
   'candidate_pool.candidate',
   'tags.tag_type',
   'approved_hours',
];
export const SLOT_SORTS = ['shift.started_at', 'squad.sequence', '-updated_at', 'candidate.first_name', 'candidate.last_name', 'id'];

export default {
   async get({
      squad_filter_id,
      board_id,
      candidate_id,
      slot_state_keys,
      date_between,
      sorts,
      includes,
      page = 1,
      per_page = 40,
      cancel_token,
      with_time_registration,
   }: {
      squad_filter_id?: number;
      board_id?: number;
      candidate_id?: number;
      slot_state_keys?: string;
      date_between?: string;
      sorts?: string;
      includes?: Array<string>;
      page: number;
      per_page: number;
      cancel_token?: CancelToken;
      with_time_registration?: boolean;
   }) {
      return await api
         .get('/slot', {
            params: {
               'filter[shift_date_between]': date_between,
               'filter[slot_state.key]': slot_state_keys,
               'filter[squad_filter_id]': squad_filter_id,
               'filter[shift.squad.board_id]': board_id,
               'filter[candidate_id]': candidate_id,
               'filter[with_time_registrations]': with_time_registration,
               include: includes,
               sort: sorts,
               page: page,
               per_page: per_page,
            },
            cancelToken: cancel_token,
         })
         .catch(() => { })
         .then((response) => response?.data);
   },
   async postPredict(body: { board_id: number; shift_ids: Array<number>; technique_key: string }) {
      return await api.post('/slot/predict', body).then((response) => {
         return response?.data;
      });
   },
   async postBulkPlanning(
      boardId: number,
      body: {
         slot_state_key: SlotStateKey;
         medium_type_key: MediumTypeKey;
         candidate_pools: Array<CandidatePool>;
         start_date?: string;
         end_date?: string;
      },
   ) {
      return await api
         .post(`/board/${boardId}/slot/bulk/planning`, body, {
            params: {
               include:
                  'candidate_pool.candidate.language,candidate_pool.candidate.tenant,candidate_pool.candidate,shift,slot_state,slot_hours',
            },
         })
         .then((response) => response?.data);
   },
   async postBulkPuzzle(boardId: number, body: { candidate_pools: Array<CandidatePool> }) {
      return await api
         .post(`/board/${boardId}/slot/bulk/puzzle`, body)
         .then((response) => response?.data);
   },
   async deleteBulkPuzzle(boardId: number, body: { candidate_pools: Array<CandidatePool> }) {
      return await api
         .delete(`/board/${boardId}/slot/bulk/puzzle`, { data: body })
         .then((response) => response?.data);
   },
   async postBulkPresence(
      boardId: number,
      body: {
         slot_state_key: SlotStateKey;
         slot_ids?: Array<number>;
         candidate_pools?: Array<CandidatePool>;
         started_at_by_shift_date?: Record<string, string>;
      },
   ) {
      return await api
         .post(`/board/${boardId}/slot/bulk/presence`, body)
         .then((response) => response?.data);
   },
   async deleteBulkPresence(boardId: number, body: { slot_ids: Array<number> }) {
      return await api
         .delete(`/board/${boardId}/slot/bulk/presence`, { data: body })
         .then((response) => response?.data);
   },
   async getBulkMove(target_squad_id: number, slot_ids: Array<number>) {
      return await api.get('/slot/bulk/move/calculate', { params: { target_squad_id, slot_ids } }).then((response) => response?.data);
   },
   async postBulkMove(body: {
      shifts: Array<Shift>;
      medium_type_key: MediumTypeKey;
      target_slot_state_key: SlotStateKey;
      target_squad_id: number;
      slot_ids: Array<number>;
   }) {
      return await api.post('/slot/bulk/move', body).then((response) => response?.data);
   },
   async createOrUpdate(body: { shift_id: number; candidate_pool_id: number }) {
      return await api
         .post('/slot/store-or-update', body, {
            params: {
               include: 'shift,candidate_pool.candidate.language,candidate_pool.candidate.tenant,candidate_pool.candidate,slot_state',
            },
         })
         .then((response) => response?.data);
   },
};
